import {Button,Card,Collapse,Input,Modal,Select,message,Upload,Image,Spin} from "antd";
// import "./AutoCrawling.css";
import axios from "axios";
import { DownloadOutlined, DeleteOutlined, LoadingOutlined  } from "@ant-design/icons";
import fileDownload from "js-file-download";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  GetACFailedClients,
  GetAutoCrawlStatus,
  Get_ReConsolidation_Clients,
} from "../../redux/TimeCardsRedux/TimeCardsActions";
import "../../GlobalCss/SPF/AutoCrawling.css";
import { useEffect, useState } from "react";
import { ErrorMessage, SuccessMessage } from "../../Utils/Utils";
import JSZip from "jszip";
import { BaseUrl, JsonConfig } from "../../Repository/BaseRepository";
import moment from "moment";
const AutoCrawling = () => {
  const [fileList, setFileList] = useState([]);
  const [uploadSpinLoader, setUploadSpinLoader] = useState(false);
  const [manualLoadingFileName, setManualLoadingFileName] = useState("");
  const [dateList, setDateList] = useState(null);
  
  //Dispatcher
  const dispatch = useDispatch();

  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");

  //Download AutoCrawled Reports
  const AutoCrawlUser = "AutoCrawling_User";

  const DownloadAutoCrawledFiles = async () => {
    console.log("Downloading");

    const url =
      `${process.env.REACT_APP_BASE_URL}Home/DownloadZipFile?filename=` +
      AutoCrawlUser +
      `&module= uspayroll`;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      responseType: "blob",
    };
    const response = await axios.get(url, config);
    fileDownload(response.data, "AutoCrawledFiles.zip");
  };

  //file uplaod functionality
  const handleFolderUpload = async (options) => {
    try {
      setUploadSpinLoader(true);

      const zipFile = options.file;
      if (!zipFile || !zipFile.name.endsWith(".zip")) {
        ErrorMessage("Please upload a valid ZIP file only.");
        setUploadSpinLoader(false);
        return;
      }

      setManualLoadingFileName(zipFile.name);
      setFileList([]);

      const zip = new JSZip();
      const zipContent = await zip.loadAsync(zipFile);

      if (Object.keys(zipContent.files).length === 0) {
        ErrorMessage(`${zipFile.name} has no files`);
        setManualLoadingFileName("");
        setUploadSpinLoader(false);
        return;
      }

      const formData = new FormData();

      await Promise.all(
        Object.keys(zipContent.files).map(async (relativePath) => {
          const entry = zipContent.files[relativePath];
          if (entry.dir) return;

          const fileData = await entry.async("blob");
          formData.append("files", new File([fileData], relativePath));
        })
      );

      const updatedFile = { file: zipFile, status: "uploading" };

      const response = await axios.post(
        `${BaseUrl}Home/FolderUploadS3bucket?moduleName=timecards&UserName=${userLogin}`,
        formData
      );

      if (response && response.data.statusCode === 200) {
        updatedFile.status = "done";
        setFileList([updatedFile]);
        setManualLoadingFileName("");
        SuccessMessage(`${zipFile.name} uploaded successfully.`);
      } else {
        updatedFile.status = "error";
        setFileList([updatedFile]);
        ErrorMessage(response.data.message || `${zipFile.name} upload failed.`);
      }

      setUploadSpinLoader(false);
      setManualLoadingFileName("");
    } catch (error) {
      setUploadSpinLoader(false);
      setManualLoadingFileName("");
      ErrorMessage("Something went wrong. Please try again.");
    }
  };
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (fileList.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div
          style={{
            color: statusColor,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          {fileExists ? fileList[0].file.name : null}
          <DeleteOutlined onClick={() => setFileList([])} />
        </div>
      </>
    );
  };


  useEffect(() => {
    fetchData();
  }, [])

  const fetchData = async () =>  {
    try {
      let url = `${BaseUrl}Home/folderUploadedDate?moduleName=timecards`
      const response = await axios.get(url, JsonConfig);
      const JsonResponse = response !== null ? response.data : null;
      if(JsonResponse != null){
        if(JsonResponse.statusCode === 200){
          if(JsonResponse.payload){
            const payloadObject = JSON.parse(JsonResponse.payload);
            setDateList(payloadObject);
          }

        } else {
          ErrorMessage(JsonResponse.message);
          return null
        }
      }
    }
    catch(err){

    }
  }


  //Get AutoCrawl Status
  const AutoCrawl = useSelector((state) => state.timecardsReducer);

  //AutoCrawl Button Background Color
  const BGColorGrey = "#EFEFEF";
  const BGColorBlue = "#3B52DF";
  const FontColorWhite = "#FFFFFF";
  const FontColorBlue = "#003A8C";
  return (
    <>
      <div className="Accordion-header">
        <div className="autocrawl-action-elements">
          <div className="vms-batchstatus">
            {/*  vms completed*/}
            <div className="vms-processed">
              <label className="form-label">Total VMS Processed :</label>
              <label className="label-value">
                {AutoCrawl.VmsCompletedCount}
              </label>
            </div>
            <br />

            {/* batch status */}
            <div className="batch-status">
              <label className="form-label">Batch Status :</label>
              <label className="label-value">{AutoCrawl.BatchLabel}</label>
            </div>
            <br />
          </div>

          {/*Crawling Action ELements */}
          <div className="crawling-block">
            <div style={{ width: "50%" }}>
              <Button
                onClick={() => {
                  dispatch(GetAutoCrawlStatus());
                  dispatch(Get_ReConsolidation_Clients());
                }}
                style={{
                  marginRight: "400px",
                  background: "#3B52DF",
                  color: "#FFFFFF",
                }}
              >
                Auto Crawl
              </Button>
              <div className="ten-manual-upload1">
                <div className="inputfile-upload1">
                  <Upload
                    className="hr-upload-file4"
                    name="file"
                    customRequest={handleFolderUpload}
                    itemRender={itemRender}
                    fileList={fileList}
                    accept=".zip"
                    onRemove={() => setFileList([])}
                    style={{
                      border: "1px solid #3B52DF",
                      borderRadius: 10,
                      borderStyle: "dashed",
                    }}
                  >
                    <div className="hr-content-file">
                      <span className="hrfile-name">Zip Folder Upload</span>
                      {uploadSpinLoader ? (
                        <Spin
                          indicator={
                            <LoadingOutlined
                              className="upload-spinner"
                              style={{
                                fontSize: 16,
                                marginLeft: 10,
                                color: "#3B52DF",
                              }}
                              spin
                            />
                          }
                        />
                      ) : (
                        // <Spin size="medium" style={{ marginLeft: '5px', marginTop:"3px" }} />
                        <Image
                          src="/Images/uploadimg (2).png"
                          style={{
                            border: "none",
                            width: 19,
                            height: 17,
                          }}
                          showPreviewIcon={false}
                          preview={false}
                        />
                      )}
                    </div>
                  </Upload>
                  {manualLoadingFileName.length > 0 ? (
                    <div
                      style={{
                        width: "fit-content",
                        wordBreak: "break-all",
                        marginBottom: 2,
                        color: "#3B52DF",
                      }}
                    >
                      {manualLoadingFileName}
                    </div>
                  ) : null}
                  <p style={{marginLeft:"30%", marginTop:"3px",color:"blue"}}>
                    Last Uploaded Date : {""}
                    {dateList && dateList.UpdatedDate && moment.utc(dateList.UpdatedDate).tz('Asia/Kolkata').format(
                      "MM/DD/YYYY HH:mm:ss"
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div style={{ width: "50%" }}>
              <Button
                style={{
                  background: AutoCrawl.EnableAutoCrawl
                    ? BGColorGrey
                    : BGColorBlue,
                  color: AutoCrawl.EnableAutoCrawl
                    ? FontColorBlue
                    : FontColorWhite,
                }}
                disabled={AutoCrawl.EnableAutoCrawl}
                onClick={() => DownloadAutoCrawledFiles()}
              >
                <span>Download AutoCrawl Reports</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AutoCrawling;
